<template>
    <div class="segment-tab">
        <div v-for="(item, index) in data" :key="index" :class="{ 'data-item': true, 'data-item-true': selectIndex == index }" @click="pickItemChange(index, item)">
            {{ titleKey ? item[`${titleKey}`] : item }}
            <div class="seg-line"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'segment-tab',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        titleKey: String,
        pickIndex: {
            type: Number,
            default: -1
        }
    },
    watch: {
        pickIndex(newValue) {
            this.selectIndex = newValue
        }
    },
    data() {
        return {
            selectIndex: this.pickIndex
        }
    },
    methods: {
        pickItemChange(index, item) {
            this.selectIndex = index
            this.$emit('changed', index, item)
        },
        forceUpdateIndex(index) {
            this.selectIndex = index
        }
    }
}
</script>
<style lang="less" scoped>
.segment-tab {
    display: flex;
    align-items: center;

    .data-item {
        position: relative;
        min-width: 60px;
        padding: 0 10px;
        height: 34px;
        line-height: 30px;
        color: @color-txt-normal;
        font-size: @font-size-large;
        &:nth-of-type(n + 2) {
            margin-left: 20px;
        }
        &:hover {
            cursor: pointer;
            color: @color-txt-high;
        }

        .seg-line {
            display: none;
            position: absolute;
            bottom: 0;
            left: 50%;
            margin-left: -15px;
            width: 30px;
            height: 4px;
            border-radius: 2px;
            background: linear-gradient(125deg, #00f14e, #02cb8a);
        }
    }
    .data-item-true {
        color: @color-txt-high;
        .seg-line {
            display: block;
        }
    }
}
</style>
